<template>
  <v-container v-if="offerData.id" :loading="loading">
    <v-row>
      <v-col>
        <v-layout row>
          <v-dialog v-model="addPositionDialog" persistent max-width="500">
            <template #activator="{ on, attrs }">
              <v-btn color="primary" dark v-bind="attrs" v-on="on">
                Position hinzufügen
              </v-btn>
            </template>
            <v-card>
              <form @submit.prevent="submitAddPosition">
                <v-card-title class="headline">
                  Position hinzufügen
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-autocomplete
                        v-model="positionToAdd"
                        :items="possiblePositions"
                        item-value="id"
                        :item-text="positionText"
                        label="Position"
                        :filter="filterPossiblePositions"
                        clearable
                        return-object
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    @click.native="addPositionDialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn color="primary" type="submit">
                    Save
                  </v-btn>
                </v-card-actions>
              </form>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="overview.data.positions"
          dense
          disable-sort
          disable-pagination
          hide-default-footer
        >
          <template #item="props">
            <tr :style="positionBackground(props.item.pos)">
              <td>{{ props.item.pos }}</td>
              <td>{{ props.item.title }}</td>
              <td>
                <v-edit-dialog
                  v-if="props.item.orderPositionItemId"
                  :return-value.sync="props.item.amount"
                  large
                  save-text="speichern"
                  cancel-text="zurück"
                  @save="updatePositionItem(props.item)"
                >
                  <div>{{ props.item.amount }}</div>
                  <template #input>
                    <div class="mt-4">
                      {{ props.item.title }}
                    </div>
                    <v-text-field
                      v-model="props.item.amount"
                      type="number"
                      label="Anzahl"
                      autofocus
                      number
                    />
                  </template>
                </v-edit-dialog>
                <div v-else>
                  {{ props.item.amount }}
                </div>
              </td>
              <td>{{ props.item.abrechnung }}</td>
              <td>
                <v-icon
                  v-if="props.item.orderPositionItemId"
                  color="error"
                  @click="deleteItem(props.item)"
                >
                  mdi-delete
                </v-icon>
                <v-icon
                  v-if="props.item.orderPositionId"
                  color="error"
                  @click="deletePosition(props.item)"
                >
                  mdi-delete
                </v-icon>
              </td>
            </tr>
            <tr v-if="props.item.orderPositionId">
              <td />
              <td colspan="3" @click="addItem(props.item.orderPositionId)">
                Add Item
              </td>
              <td />
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-layout row justify-center>
      <v-dialog v-model="addItemDialog" persistent max-width="500">
        <v-card>
          <form @submit.prevent="submitAddItem">
            <v-card-title class="headline">
              Item zu Position hinzufügen
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-autocomplete
                    v-model="addItemForm.itemId"
                    :items="items"
                    item-value="id"
                    :error-messages="itemIdErrors"
                    :item-text="itemText"
                    label="Item"
                    :filter="filterItems"
                    clearable
                    @blur="$v.addItemForm.itemId.$touch()"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="addItemForm.amount"
                    :error-messages="amountErrors"
                    type="number"
                    name="amount"
                    label="Anzahl"
                    single-line
                    @blur="$v.addItemForm.amount.$touch()"
                  />
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="error" @click.native="addItemDialog = false">
                Cancel
              </v-btn>
              <v-btn color="primary" type="submit">
                Add
              </v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'
import { validationMixin } from 'vuelidate'
import { required, minValue } from 'vuelidate/lib/validators'
function inItems (value) {
   return this.items.find(({ id }) => id === value) !== undefined
}

export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'manuelles Editieren',
      }
   },
   mixins: [validationMixin],
   layout: (h, page) => h(Layout, [page]),
   props: {
      offerData: {
         type: Object,
         required: true,
      },
      overview: {
         type: Object,
         required: true,
      },
      items: {
         type: Array,
         required: true,
      },
      products: {
         type: Array,
         required: true,
      },
      bundles: {
         type: Array,
         required: true,
      },
   },
   validations: {
      addItemForm: {
         itemId: { required, inItems },
         amount: { required, minValue: minValue(0) },
      },
   },
   data () {
      return {
         addItemForm: this.$inertia.form({
            itemId: null,
            amount: null,
         }),
         addPositionForm: this.$inertia.form({
            id: null,
            type: null,
         }),
         addPositionDialog: false,
         addItemDialog: false,
         editingPosition: null,
         loading: true,
         positionToAdd: null,
         tab: 0,
         headers: [
            {
               text: 'Pos.',
               align: 'start',
               filterable: false,
               value: 'pos',
            },
            { text: 'Beschreibung', value: 'title' },
            { text: 'Anz.', value: 'amount' },
            { text: 'Art.', value: 'abrechnung' },
            {
               text: 'Aktionen',
               filterable: false,
            },
         ],
      }
   },
   computed: {
      amountErrors () {
         const errors = this.$page.props.errors.amount ?? []
         if (!this.$v.addItemForm.amount.$dirty) return errors
         !this.$v.addItemForm.amount.required &&
        errors.push('Amount is required.')
         !this.$v.addItemForm.amount.minValue &&
        errors.push('Amount must be greater 0')
         return errors
      },
      itemIdErrors () {
         const errors = this.$page.props.errors.itemId ?? []
         if (!this.$v.addItemForm.itemId.$dirty) return errors
         !this.$v.addItemForm.itemId.required && errors.push('Field is required.')
         !this.$v.addItemForm.itemId.inItems &&
        errors.push('Muss einem Artikel entsprechen')

         return errors
      },
      possiblePositions () {
         return this.bundles.concat(this.products)
      },
   },
   methods: {
      publishItem () {
         this.$inertia.post(
            this.route('offer.store', {
               offerData: this.offerData.id,
               term: this.term,
            })
         )
      },
      positionBackground (pos) {
         return {
            backgroundColor:
          pos !== undefined && !String(pos).includes('.')
             ? 'gray'
             : 'transparent',
         }
      },
      updatePositionItem (val) {
         this.$inertia.patch(
            this.route('positionitem.update', val.orderPositionItemId),
            { amount: val.amount },
            {
               preserveScroll: true,
            }
         )
      },
      addItem (position) {
         this.editingPosition = position
         this.addItemDialog = true
      },
      submitAddItem () {
         this.$v.$touch()
         if (!this.$v.$invalid) {
            this.addItemForm.post(
               this.route('offerData.addPositonItem', {
                  offerData: this.offerData.id,
                  position: this.editingPosition,
               }),
               {
                  preserveScroll: true,
                  onSuccess: (response) => {
                     console.log(this.addItemForm)
                     if (this.addItemForm.wasSuccessful) {
                        this.addItemDialog = false
                        this.editingPosition = null
                        this.addItemForm.reset()
                        this.$v.$reset()
                     }
                  },
               }
            )
         }
      },
      submitAddPosition () {
         if (this.positionToAdd.last_data[0].bundle_id) {
            this.addPositionForm.id = this.positionToAdd.last_data[0].bundle_id
            this.addPositionForm.type = 'Bundle'
         } else {
            this.addPositionForm.id = this.positionToAdd.last_data[0].product_id
            this.addPositionForm.type = 'Product'
         }
         this.addPositionForm.post(
            this.route('offerData.addPosition', {
               offerData: this.offerData.id,
            }),
            {
               preserveScroll: true,
               onSuccess: (response) => {
                  if (this.addPositionForm.wasSuccessful) {
                     this.addPositionDialog = false
                     this.positionToAdd = null
                     this.addPositionForm.reset()
                     this.$v.$reset()
                  }
               },
            }
         )
      },
      deletePosition (item) {
         if (
            confirm(`Soll die Position ${item.title} wirklich gelöscht werden?`)
         ) {
            this.$inertia.delete(
               this.route('position.delete', item.orderPositionId),
               {
                  preserveScroll: true,
               }
            )
         }
      },
      deleteItem (item) {
         if (confirm(`Soll der Artikel ${item.title} wirklich gelöscht werden?`)) {
            this.$inertia.delete(
               this.route('positionitem.delete', item.orderPositionItemId),
               {
                  preserveScroll: true,
               }
            )
         }
      },
      itemText (item) {
         return item.product.last_data[0].name + ' - ' + item.last_data[0].name
      },
      positionText (item) {
         return item.last_data[0].name
      },
      filterItems (item, queryText, itemText) {
         const textOne = item.product.last_data[0].name.toLowerCase()
         const textTwo = item.last_data[0].name.toLowerCase()
         const searchText = queryText.toLowerCase()

         return (
            textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
         )
      },
      filterPossiblePositions (item, queryText, itemText) {
         const searchText = queryText.toLowerCase()
         const textOne = item.last_data[0].name.toLowerCase()

         return textOne.indexOf(searchText) > -1
      },
   },
}
</script>
